<script setup lang="ts">
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import XLayout from "./AuthLayout/XLayout.vue";
</script>

<template>
  <div class="flex flex-col min-h-screen gap-4 justify-between">
    <div>
      <Header />

      <main class="xl:w-[1200px] mx-2 sm:mx-4 md:mx-6 xl:mx-auto">
        <XLayout v-if="$route.meta.isXLayout">
          <slot />
        </XLayout>
        <slot v-else />
      </main>
    </div>

    <Footer />
  </div>
</template>
